export default __webpack_public_path__ + "static/media/bobman426-KHC13_1A.5009adf4.png";